<template>
  <o-table :title="$t('medtastic.workshops')" url="/api/medtastic/workshops">
    <template slot="filter">
      <b-btn @click.prevent="xlsx()" variant="primary" class="mt-3">
        <fa icon="file-excel"/> {{$t('medtastic.export')}}
      </b-btn>
    </template>
    <template slot="head">
      <o-table-header column="title">{{$t('core.title')}}</o-table-header>
      <o-table-header column="location">{{$t('medtastic.location')}}</o-table-header>
      <o-table-header column="date">{{$t('core.date')}}</o-table-header>
      <o-table-header column="time">{{$t('medtastic.time')}}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.title }}</td>
      <td>{{ props.item.location }}</td>
      <td>{{ props.item.date | formatDate }}</td>
      <td>{{ props.item.time | formatTimeString }}</td>
    </template>
  </o-table>
</template>

<script>
  import axios from 'axios'

  export default {
    methods: {
      xlsx () {
        axios.get(`/api/medtastic/workshops/export`, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(response.data,
              'workshops' + new Date().toISOString().slice(0, 10) + '.xlsx', 'application/vnd.ms-excel'
            )
          }).catch((error) => {
            console.log(error)
          })
      }
    }
  }
</script>
